import type { ObjectId } from '@freightview/object-id'

import { type vInput, vObject, vObjectId } from '../validation/index.ts'

export const addInterestedAccountSchema = vObject({
  accountId: vObjectId(),
})

export type AddInterestedAccountDto = vInput<typeof addInterestedAccountSchema>

export interface InterestedAccountDto {
  accountId: ObjectId
  company: string
  addedAt: Date
  addedBy?: ObjectId
}
